










import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ReceiptHeader extends Vue {
  private get orderId(): string {
    return this.$store.state.order.orderReceipt?.id;
  }
}
